const translations = {
    en: {
        title: "شركة مجوهرات النابي",
        home: "Home",
        news: "News",
        eliteClub: "Elite Club",
        priceCalculator: "Price Calculator",
        institute: "Dar Alsabaek Institute",
        about: "About Us",
        contact: "Contact Us",
        login: "Login",
        cart: "Shopping Cart",
        store: "Store",
        products: "Gold Jewellery",
        productDetail: "Product Details",
        search: "Search products...",
        filter: "Filter",
        addToCart: "Add to Cart",
        addToWishlist: "Add to Wishlist",
        removeFromWishlist: "Remove from Wishlist",
        share: "Share",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        freeShipping: "Quick Shipping",
        securePayment: "Secure Payment",
        productNotFound: "Product not found",
        loading: "Loading...",
        kwd: "KD",
        category: "Category",
        metal: "Metal",
        karat: "Karat",
        weight: "Weight",
        dimensions: "Dimensions",
        description: "Description",
        specifications: "Specifications",
        reviews: "Reviews",
        relatedProducts: "Related Products",
        viewAll: "View All",
        quantity: "Quantity",
        overview: "Overview",
        details: "Details",
        customerReviews: "Customer Reviews",
        shipping: "Shipping & Returns",
        lowStock: "Low Stock",
        onSale: "On Sale",
        originalPrice: "Original Price",
        discount: "Discount",
        makingCharges: "Making Charges",
        totalPrice: "Total Price",
        style: "Style",
        occasion: "Occasion",
        compareProducts: "Compare Products",
        viewInAR: "View in AR",
        sizeGuide: "Size Guide",
        returnPolicy: "Return Policy",
        warranty: "Warranty",
        authenticity: "Authenticity Guarantee",
        trusted: "Trusted by thousands",
        buyNow: "Buy Now",
        wishlist: "Wishlist",
        compare: "Compare",
        goldPrice: "Gold Price",
        silverPrice: "Silver Price",
        platinumPrice: "Platinum Price",
        realTimeChart: "Live Chart",
        karat24: "karat 24 (Gm)",
        karat22: "karat 22 (Gm)",
        karat21: "karat 21 (Gm)",
        karat18: "karat 18 (Gm)",
        silver: "Silver (Gm)",
        platinum: "Platinum (Gm)",
        pricesUpdate: "Prices will be updated in {seconds} seconds according to international price",
        gold: "Gold",
        timeframes: ["10m", "1h", "6h", "1d", "3d", "7d", "More"],
        downloadApp: "You can download our APP now!",
        appStore: "App Store",
        googlePlay: "Google Play",
        help: "Help",
        quickLinks: 'Quick Links',
        contactInfo: 'Contact Information',
        profile:'Profile',
        address: 'Mubarkiya, Al-Raya Gold Center, First Floor, Shop 18',
        phone: '+96566111290',
        email: 'info@dhahabjw.com',
        followUs: 'Follow Us',
        newsletter: 'Newsletter',
        newsletterText: 'Subscribe to get updates on new arrivals and exclusive offers',
        subscribe: 'Subscribe',
        enterEmail: 'Enter your email',
        services: 'Our Services',
        customJewelry: 'Custom Jewelry',
        goldBuying: 'Gold Buying',
        appraisal: 'Jewelry Appraisal',
        emiOption: "Installment Option",
        emiDescription: "As low as {amount} {currency}/month or 4 interest-free payments.",
        learnMore: "Learn more",
        kwd: "KD",
        repair: 'Repair Service',
        allRightsReserved: 'All rights reserved.',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        brandDescription: 'Best vendor for Gold Jewellery in Gulf since 2025.',
        instagramLabel: 'Instagram',
        tiktokLabel: 'TikTok',
        livePricing: "Live precious metals pricing",
        noHistoricalData: "No historical data available for",
        tryRefreshing: "Try refreshing or selecting a different metal",
        addedToCart: 'Product added to cart successfully!',
        addToCartError: 'Failed to add product to cart',
        removeFromCart: 'Remove from cart',
        removeFromCartError: 'Failed to remove product from cart',
        removedFromCart: 'Product removed from cart successfully!',
        loginRequired: 'Please login to continue',
        invalidRequest: 'Invalid request',
        timeout: 'Request timeout. Please try again.',
        networkError: 'Network error. Please check your connection.',
        inCart: 'In Cart',
        adding: 'Adding...',
        add: 'Add',
        removing: 'Removing...',
        remove: 'Remove',
        itemNotFound: 'Item not found in cart',
        noProductsFound: 'No products found',
        welcome: "Welcome",
        logout: "Logout",
        logoutShort: "Out",
        loginSubtitle: "Welcome back! Please login to your account.",
        registerSubtitle: "Create a new account to get started.",
        register: "Register",
        emailLabel: "Email",
        password: "Password",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        signIn: "Sign In",
        firstName: "First Name",
        middleName: "Middle Name",
        familyName: "Family Name",
        civilId: "Civil ID",
        paymentLink: "Request link",
        tabbyLink: "⁠Request tabby link",
        country: "Country",
        nationality: "Nationality",
        confirmPassword: "Confirm Password",
        passwordNote: "Password must be at least 6 characters long.",
        agreeTermsTextPrefix: "I agree to the ",
        and: " and ",
        off: 'OFF',
        price: 'Price',
        backToStore: 'Back to Store',
        onlyXLeft: 'Only {count} items left in stock!',
        continueShopping: 'Continue Shopping',
        createAccount: "Create Account",
        emptyCart: "Your cart is empty",
        emptyCartMessage: "Looks like you haven't added any items to your cart yet.",
        startShopping: "Start Shopping",
        unitPrice: "Unit Price",
        total: "Total",
        orderSummary: "Order Summary",
        subtotal: "Subtotal",
        item: "item",
        items: "items",
        free: "Free",
        proceedToCheckout: "Proceed to Checkout",
        secureCheckout: "Secure checkout guaranteed",
        confirmRemove: "Confirm Remove",
        confirmRemoveMessage: "Are you sure you want to remove this item from your cart?",
        cancel: "Cancel",
        pickupDetails: 'Pickup Details',
        storePickup: 'Store Pickup',
        homeDelivery: 'Home Delivery',
        location: 'Location',
        pickupFee: 'Pickup Fee',
        delivery: 'Delivery',
        checkout: "Checkout",
        shippingInformation: "Shipping Information",
        paymentMethod: "Payment Method",
        orderConfirmation: "Order Confirmation",
        deliveryInformation: "Delivery Information",
        deliveryOption: "Delivery Option",
        homeDeliveryOption: "Home Delivery",
        homeDeliveryDesc: "Get your order delivered to your address",
        storePickupOption: "Store Pickup",
        storePickupDesc: "Pick up your order from our store (Free)",
        selectDeliveryOption: "Please select a delivery option",
        shippingAddress: "Shipping Address",
        addressType: "Address Type",
        selectType: "Select Type",
        apartment: "Apartment",
        house: "House",
        office: "Office",
        area: "Area",
        block: "Block",
        streetName: "Street Name",
        streetNumber: "Street Number",
        avenue: "Avenue",
        buildingName: "Building Name",
        buildingNumber: "Building Number",
        floor: "Floor",
        apartmentNumber: "Apartment Number",
        company: "Company",
        additionalDirections: "Additional Directions",
        phoneNumber: "Phone Number",
        addressLabel: "Address Label (e.g. Home, Office)",
        addressTypeRequired: "Address type is required",
        areaRequired: "Area is required",
        phoneRequired: "Phone number is required",
        invalidPhoneFormat: "Invalid phone number format",
        apartmentNumberRecommended: "Apartment number is recommended for Apartment addresses",
        buildingNameOrNumber: "Provide either building name or number",
        streetNameOrNumber: "Provide either street name or number",
        storePickupDetails: "Store Pickup Details",
        storeLocation: "Store Location",
        selectStoreLocation: "Select Store Location",
        contactPhoneNumber: "Contact Phone Number",
        pickupContactRequired: "Contact phone is required for pickup",
        pickupPhoneHelper: "We will call you when your order is ready for pickup",
        storePickupInfo: "Store Pickup Information:",
        pickupReadyTime: "• Orders are usually delivered within 48 hours.",
        pickupNotification: "• We will call you when your order is ready",
        pickupIdRequired: "• Please bring a valid ID when picking up your order",
        pickupFreeCharge: "• Store pickup is free of charge",
        kuwaitCityMain: "Kuwait City - Main Branch",
        hawalliBranch: "Hawalli - Branch",
        salmiyaBranch: "Salmiya - Branch",
        farwaniyaBranch: "Farwaniya - Branch",
        selectPaymentMethod: "Select Payment Method",
        creditDebitCard: "Credit/Debit Card",
        kNet: "K-Net",
        cashOnDelivery: "Cash on Delivery",
        cardNumber: "Card Number",
        expiryDate: "MM/YY",
        cvv: "CVV",
        cardholderName: "Cardholder Name",
        cardNumberRequired: "Card number is required",
        expiryDateRequired: "Expiry date is required",
        cvvRequired: "CVV is required",
        cardNameRequired: "Cardholder name is required",
        jewelry: "Jewelry",
        tax: "Tax (5%)",
        orderPlacedSuccess: "Order Placed Successfully!",
        orderNumber: "Order Number",
        thankYouMessage: "Thank you for your purchase! You will receive an email confirmation shortly. Your order will be delivered in a maximum of 48 hours.",
        continueShoppingBtn: "Continue Shopping",
        viewOrdersBtn: "View Orders",
        processing: "Processing...",
        placeOrder: "Place Order",
        orderPlacementFailed: "Failed to place order. Please try again.",
        orderPlacementError: "An error occurred while placing the order. Please check your details and try again.",
        paymentSecure: "Your payment information is secure and encrypted",
        termsAgreement: "By placing this order, you agree to our Terms of Service and Privacy Policy. Your jewelry will be carefully inspected and packaged before",
        readyForPickup: "being ready for pickup",
        back: "Back",
        next: "Next",
        orderPending: "Pending",
        orderConfirmed: "Confirmed",
        orderProcessing: "Processing",
        orderShipped: "Shipped",
        orderDelivered: "Delivered",
        orderCancelled: "Cancelled",
        phoneLabel: "Phone Number",
        orderRefunded: "Refunded",
        filterByStatus: "Filter by Status",
        allOrders: "All Orders",
        noOrdersWithStatus: "No orders found with this status",
        noOrders: "No orders yet",
        tryDifferentFilter: "Try selecting a different status filter",
        noOrdersMessage: "You haven't placed any orders yet. Start shopping to see your orders here.",
        hideDetails: "Hide Details",
        viewDetails: "View Details",
        orderItems: "Order Items",
        pricingSummary: "Pricing Summary",
        steps: {
            shippingInformation: "Shipping Information",
            paymentMethod: "Payment Method",
            orderConfirmation: "Order Confirmation"
        },
        allProducts: "All Products",
        agreeToTerms: 'I agree to the',
        termsAndConditions: 'Terms and Conditions',
        termsRequired: 'You must accept the terms and conditions to proceed',
    },
    ar: {
        allProducts: "جميع المنتجات",
        title: "دهب",
        home: "الرئيسية",
        news: "الأخبار",
        eliteClub: "النادي المميز",
        priceCalculator: "حاسبة السعر",
        institute: "معهد دار السباعك",
        about: "من نحن",
        contact: "اتصل بنا",
        login: "تسجيل الدخول",
        cart: "سلة التسوق",
        store: "المتجر",
        products: "المجوهرات الذهبية",
        productDetail: "تفاصيل المنتج",
        search: "البحث عن المنتجات...",
        filter: "تصفية",
        addToCart: "أضف إلى السلة",
        addToWishlist: "أضف إلى المفضلة",
        removeFromWishlist: "إزالة من المفضلة",
        share: "مشاركة",
        inStock: "متوفر",
        outOfStock: "غير متوفر",
        freeShipping: "الشحن السريع",
        securePayment: "دفع آمن",
        productNotFound: "المنتج غير موجود أو غير متاح",
        loading: "جاري التحميل...",
        kwd: "د.ك",
        category: "الفئة",
        metal: "المعدن",
        karat: "عيار",
        weight: "الوزن",
        dimensions: "الأبعاد",
        description: "الوصف",
        specifications: "المواصفات",
        reviews: "التقييمات",
        relatedProducts: "منتجات ذات صلة",
        viewAll: "عرض الكل",
        quantity: "الكمية",
        overview: "نظرة عامة",
        details: "التفاصيل",
        customerReviews: "تقييمات العملاء",
        shipping: "الشحن",
        lowStock: "مخزون منخفض",
        onSale: "خصم",
        originalPrice: "السعر الأصلي",
        discount: "الخصم",
        makingCharges: "رسوم التصنيع",
        totalPrice: "السعر الإجمالي",
        style: "الطراز",
        occasion: "المناسبة",
        compareProducts: "مقارنة المنتجات",
        viewInAR: "عرض بالواقع المعزز",
        sizeGuide: "دليل المقاسات",
        returnPolicy: "سياسة الإرجاع",
        warranty: "الضمان",
        authenticity: "ضمان الأصالة",
        trusted: "موثوق من آلاف العملاء",
        buyNow: "اشتر الآن",
        wishlist: "المفضلة",
        compare: "مقارنة",
        goldPrice: "سعر الذهب",
        silverPrice: "سعر الفضة",
        platinumPrice: "سعر البلاتين",
        realTimeChart: "الرسم البياني المباشر",
        karat24: "عيار 24 (جم)",
        karat22: "عيار 22 (جم)",
        karat21: "عيار 21 (جم)",
        karat18: "عيار 18 (جم)",
        silver: "فضة (جم)",
        platinum: "بلاتين (جم)",
        pricesUpdate: "سيتم تحديث الأسعار خلال {seconds} ثانية حسب السعر العالمي",
        gold: "ذهب",
        timeframes: ["10د", "1س", "6س", "1ي", "3أ", "7أ", "المزيد"],
        downloadApp: "يمكنك تحميل التطبيق الآن!",
        appStore: "متجر التطبيقات",
        googlePlay: "جوجل بلاي",
        help: "مساعدة",
        quickLinks: "روابط سريعة",
        contactInfo: "معلومات الاتصال",
        address: "Mubarkiya, Al-Raya Gold Center, First Floor, Shop 18",
        phone: "+96566111290",
        email: "info@dhahabjw.com",
        emailLabel: "البريد الإلكتروني",
        followUs: "تابعنا",
        newsletter: "النشرة الإخبارية",
        newsletterText: "اشترك للحصول على تحديثات حول الوصولات الجديدة والعروض الحصرية",
        subscribe: "اشترك",
        enterEmail: "أدخل بريدك الإلكتروني",
        services: "خدماتنا",
        customJewelry: "مجوهرات مخصصة",
        goldBuying: "شراء الذهب",
        appraisal: "تقييم المجوهرات",
        repair: "خدمة الإصلاح",
        allRightsReserved: "جميع الحقوق محفوظة.",
        privacyPolicy: "سياسة الخصوصية",
        termsOfService: "شروط الخدمة",
        brandDescription: "شريكك الموثوق للمجوهرات الذهبية الفاخرة والمعادن الثمينة. جودة الصناعة منذ عام ٢٠١٨.",
        instagramLabel: "إنستغرام",
        tiktokLabel: "تيك توك",
        livePricing: "أسعار المعادن الثمينة مباشرة",
        noHistoricalData: "لا توجد بيانات تاريخية متاحة لـ",
        tryRefreshing: "حاول التحديث أو اختيار معدن مختلف",
        emiOption: "خيار الدفع بالتقسيط",
        emiDescription: "بدءاً من {amount} {currency}/شهر أو 4 دفعات بدون فوائد.",
        learnMore: "اعرف المزيد",
        kwd: "د.ك",
        addedToCart: "تمت إضافة المنتج إلى السلة بنجاح!",
        addToCartError: "فشل في إضافة المنتج إلى السلة",
        removeFromCartError: "فشل في إزالة المنتج من السلة",
        removedFromCart: "تمت إزالة المنتج من السلة بنجاح!",
        loginRequired: "يرجى تسجيل الدخول للمتابعة",
        invalidRequest: "طلب غير صالح",
        timeout: "انتهت مهلة الطلب. حاول مرة أخرى.",
        networkError: "خطأ في الشبكة. يرجى التحقق من الاتصال.",
        inCart: "في السلة",
        adding: "جارٍ الإضافة...",
        add: "إضافة",
        removing: "جارٍ الإزالة...",
        remove: "إزالة",
        itemNotFound: "العنصر غير موجود في السلة",
        noProductsFound: "لم يتم العثور على منتجات",
        removeFromCart: "إزالة من العربة",
        welcome: "مرحبًا",
        logout: "تسجيل الخروج",
        logoutShort: "خروج",
        loginSubtitle: "مرحبًا بعودتك! الرجاء تسجيل الدخول إلى حسابك.",
        registerSubtitle: "قم بإنشاء حساب جديد للبدء.",
        register: "تسجيل",
        password: "كلمة المرور",
        rememberMe: "تذكرني",
        forgotPassword: "هل نسيت كلمة المرور؟",
        signIn: "تسجيل الدخول",
        firstName: "الاسم الأول",
        middleName: "الاسم الأوسط",
        familyName: "اسم العائلة",
        civilId: "الرقم المدني",
        country: "البلد",
        nationality: "الجنسية",
        confirmPassword: "تأكيد كلمة المرور",
        passwordNote: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
        agreeTermsTextPrefix: "أوافق على ",
        and: " و ",
        createAccount: "إنشاء حساب",
        off: "خصم",
        price: "السعر",
        backToStore: "العودة إلى المتجر",
        onlyXLeft: "متبقي فقط {count} قطعة في المخزون!",
        continueShopping: "مواصلة التسوق",
        emptyCart: "سلة التسوق فارغة",
        emptyCartMessage: "يبدو أنك لم تضف أي عناصر بعد.",
        startShopping: "ابدأ التسوق",
        unitPrice: "سعر الوحدة",
        total: "المجموع",
        orderSummary: "ملخص الطلب",
        subtotal: "المجموع الفرعي",
        item: "عنصر",
        items: "عناصر",
        free: "مجاني",
        proceedToCheckout: "المتابعة للدفع",
        secureCheckout: "الدفع الآمن مضمون",
        confirmRemove: "تأكيد الإزالة",
        confirmRemoveMessage: "هل أنت متأكد أنك تريد إزالة هذا العنصر من سلة التسوق؟",
        cancel: "إلغاء",
        pickupDetails: "تفاصيل الاستلام",
        storePickup: "استلام من المتجر",
        homeDelivery: "التوصيل المنزلي",
        location: "الموقع",
        pickupFee: "رسوم الاستلام",
        delivery: "التوصيل",
        checkout: "الدفع",
        shippingInformation: "معلومات الشحن",
        paymentMethod: "طريقة الدفع",
        orderConfirmation: "تأكيد الطلب",
        deliveryInformation: "معلومات التوصيل",
        deliveryOption: "خيار التوصيل",
        homeDeliveryOption: "التوصيل المنزلي",
        homeDeliveryDesc: "احصل على طلبك مُوصل إلى عنوانك",
        storePickupOption: "الاستلام من المتجر",
        storePickupDesc: "استلم طلبك من متجرنا (مجاناً)",
        selectDeliveryOption: "يرجى اختيار خيار التوصيل",
        shippingAddress: "عنوان الشحن",
        addressType: "نوع العنوان",
        selectType: "اختر النوع",
        apartment: "شقة",
        house: "منزل",
        office: "مكتب",
        area: "المنطقة",
        block: "القطعة",
        streetName: "اسم الشارع",
        streetNumber: "رقم الشارع",
        avenue: "الجادة",
        buildingName: "اسم المبنى",
        buildingNumber: "رقم المبنى",
        floor: "الطابق",
        apartmentNumber: "رقم الشقة",
        company: "الشركة",
        additionalDirections: "توجيهات إضافية",
        phoneNumber: "رقم الهاتف",
        addressLabel: "تسمية العنوان (مثل: المنزل، المكتب)",
        addressTypeRequired: "نوع العنوان مطلوب",
        areaRequired: "المنطقة مطلوبة",
        phoneRequired: "رقم الهاتف مطلوب",
        invalidPhoneFormat: "صيغة رقم الهاتف غير صحيحة",
        apartmentNumberRecommended: "رقم الشقة مُوصى به لعناوين الشقق",
        buildingNameOrNumber: "قدم إما اسم المبنى أو رقمه",
        streetNameOrNumber: "قدم إما اسم الشارع أو رقمه",
        storePickupDetails: "تفاصيل الاستلام من المتجر",
        storeLocation: "موقع المتجر",
        selectStoreLocation: "اختر موقع المتجر",
        contactPhoneNumber: "رقم هاتف الاتصال",
        pickupContactRequired: "هاتف الاتصال مطلوب للاستلام",
        pickupPhoneHelper: "سنتصل بك عندما يصبح طلبك جاهزاً للاستلام",
        storePickupInfo: "معلومات الاستلام من المتجر:",
        pickupReadyTime: "• الطلبات جاهزة عادة للاستلام خلال 2-3 أيام عمل",
        pickupNotification: "• سنتصل بك عندما يصبح طلبك جاهزاً",
        pickupIdRequired: "• يرجى إحضار هوية صالحة عند استلام طلبك",
        pickupFreeCharge: "• الاستلام من المتجر مجاني",
        kuwaitCityMain: "مدينة الكويت - الفرع الرئيسي",
        hawalliBranch: "حولي - فرع",
        salmiyaBranch: "السالمية - فرع",
        farwaniyaBranch: "الفروانية - فرع",
        selectPaymentMethod: "اختر طريقة الدفع",
        creditDebitCard: "بطاقة ائتمان/خصم",

        kNet: "كي نت",
        cashOnDelivery: "الدفع عند الاستلام",
        cardNumber: "رقم البطاقة",
        expiryDate: "ش.س/س.س",
        cvv: "رمز الأمان",
        cardholderName: "اسم حامل البطاقة",
        cardNumberRequired: "رقم البطاقة مطلوب",
        expiryDateRequired: "تاريخ الانتهاء مطلوب",
        cvvRequired: "رمز الأمان مطلوب",
        cardNameRequired: "اسم حامل البطاقة مطلوب",
        jewelry: "مجوهرات",
        tax: "الضريبة (5%)",
        agreeToTerms: 'أوافق على',
        termsAndConditions: 'الشروط والأحكام',
        termsRequired: 'يجب عليك قبول الشروط والأحكام للمتابعة',
        orderPlacedSuccess: "تم تقديم الطلب بنجاح!",
        orderNumber: "رقم الطلب",
        thankYouMessage: "شكراً لك على الشراء! ستتلقى تأكيداً بالبريد الإلكتروني قريباً. سيتم تغليف مجوهراتك بعناية وشحنها خلال 2-3 أيام عمل.",
        continueShoppingBtn: "مواصلة التسوق",
        viewOrdersBtn: "عرض الطلبات",
        processing: "جارٍ المعالجة...",
        placeOrder: "تقديم الطلب",
        orderPlacementFailed: "فشل في تقديم الطلب. حاول مرة أخرى.",
        orderPlacementError: "حدث خطأ أثناء تقديم الطلب. يرجى التحقق من تفاصيلك والمحاولة مرة أخرى.",
        paymentSecure: "معلومات الدفع آمنة ومشفرة",
        termsAgreement: "بتقديم هذا الطلب، فإنك توافق على شروط الخدمة وسياسة الخصوصية. سيتم فحص مجوهراتك وتغليفها بعناية قبل",
        readyForPickup: "جاهزيتها للاستلام",
        back: "السابق",
        next: "التالي",
        steps: {
            shippingInformation: "معلومات الشحن",
            paymentMethod: "طريقة الدفع",
            orderConfirmation: "تأكيد الطلب"
        },
        orderPending: "في الانتظار",
        orderConfirmed: "مؤكد",
        orderProcessing: "قيد المعالجة",
        orderShipped: "تم الشحن",
        orderDelivered: "تم التسليم",
        orderCancelled: "ملغي",
        orderRefunded: "مسترد",
        filterByStatus: "تصفية حسب الحالة",
        phoneLabel: "رقم التليفون",
        allOrders: "جميع الطلبات",
        noOrdersWithStatus: "لم يتم العثور على طلبات بهذه الحالة",
        noOrders: "لا توجد طلبات بعد",
        tryDifferentFilter: "جرب اختيار مرشح حالة مختلف",
        noOrdersMessage: "لم تقم بتقديم أي طلبات بعد. ابدأ التسوق لرؤية طلباتك هنا.",
        hideDetails: "إخفاء التفاصيل",
        profile:"حساب تعريفي",
        viewDetails: "عرض التفاصيل",
        orderItems: "عناصر الطلب",
        pricingSummary: "ملخص الأسعار",
        paymentLink: "طلب رابط",
        tabbyLink: "طلب رابط تابى",
    }
};

export default translations;